import { getModernImageThemes } from "../utils/getModernThemes";
import { getThemeIdFromParameter } from "../utils/optionalArgumentHelpers";

export default function getIsCurrentThemeModernImage(themeId?: string): boolean {
    themeId = getThemeIdFromParameter(themeId);
    
    return getModernImageThemes().includes(themeId);
}
